module.exports = __webpack_public_path__ + "img/logo.0fb5be02.png";